import React from "react";

type Props = {
  heading: string;
  subHeading?: string;
  textAlign?: "text-center" | "text-left" | "text-right" | string;
};

export default function HeadingSection({ heading, subHeading, textAlign = "text-center" }: Props) {
  return (
    <>
      {heading && <h2 className={`px-2.5 sm:px-0 text-xl sm:text-2xl lg:text-3xl font-bold ${textAlign} text-white ${subHeading ? "mb-3" : "mb-4 sm:mb-10"}`}>{heading}</h2>}
      {subHeading && <p className={`px-2.5 sm:px-0 text-sm sm:text-base lg:text-xl ${textAlign} text-white mb-4 sm:mb-10`}>{subHeading}</p>}
    </>
  );
}
